import { PIcon } from '@porsche-design-system/components-react';
import TimePickerField, { type TimePickerFieldProps } from '../../../components/fields/TimePickerField';
import ClockIcon from '../../../icons/mobility/clock.svg';
import { RangePickerContainer } from './shared';

const TimeRangePickerField = ({ disabled, ...props }: TimePickerFieldProps) => (
    <RangePickerContainer disabled={Array.isArray(disabled) ? disabled.some(Boolean) : disabled}>
        <TimePickerField
            {...props}
            disabled={disabled}
            errorIcon={
                <PIcon aria={{ 'aria-label': 'Exclamation icon' }} color="notification-error" name="exclamation" />
            }
            suffixIcon={<ClockIcon />}
        />
    </RangePickerContainer>
);

export default TimeRangePickerField;
